module.exports = __webpack_public_path__ + "dec5f6141a47eebeda75271ffb083611.png";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/BKM_Neustart_Kultur_Wortmarke_neg_RGB_RZ.png
// module id = 958
// module chunks = 0